import styled from "styled-components";
import {HEADER_Z_INDEX} from "../../../../header/header-consts";

export const VideoSlidesArenaHeaderDefaultBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    min-height: 40px;
    padding: 5px 0px 10px 0px;
    width: 100%;
    background-color: ${props => props.theme.colors.backgroundDark};
    border-bottom: 1px solid #232323;
    z-index: ${HEADER_Z_INDEX};
`